import {mergeAll, scan, throttleTime, shareReplay} from 'rxjs/operators';
import {spotMarket24h$} from './market24h-spot';
import type {SpotMarket} from '@/types';

export const spotMarketCache$ = spotMarket24h$.pipe(
  mergeAll(),
  scan((p: Map<string, SpotMarket>, c: SpotMarket) => p.set(c.symbol, c), new Map()),
  throttleTime(100),
  shareReplay(1)
);
